import React, { useState, useEffect } from 'react';
import { Tab, Tabs, Typography } from '@mui/material';
import DashboardContainer from '../../components/admin/DashboardContainer';
import LibraryList from '../../components/admin/library/LibraryList';
import SaveContent from '../../components/admin/library/SaveContent';
import { supabase } from '../../supabaseClient';

const Library = () => {
  const [videos, setVideos] = useState([]);
  const [podcasts, setPodcasts] = useState([]);
  const [books, setBooks] = useState([]);
  const [articles, setArticles] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  // get data from Supabase and filter by category
  const fetchData = async () => {
    const { data, error } = await supabase.from('library').select('*');

    if (error) return console.log(error);

    // Filter data by category
    const videoData = data.filter((item) => item.type === 'video' || item.type === 'youtube');
    const podcastData = data.filter((item) => item.type === 'podcast');
    const bookData = data.filter((item) => item.type === 'book');
    const articleData = data.filter((item) => item.type === 'article');

    setVideos(videoData);
    setPodcasts(podcastData);
    setBooks(bookData);
    setArticles(articleData);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <DashboardContainer title={'Biblioteca'}>
      <Tabs value={activeTab} onChange={handleTabChange} variant="fullWidth">
        <Tab label="Videos" />
        <Tab label="Episodios de podcast" />
        <Tab label="Libros" />
        <Tab label="Artículos" />
      </Tabs>
      {activeTab === 0 && (
        <div>
          <Typography variant="h6" component="div" mt={2}>
            Videos
          </Typography>
          <LibraryList library={videos} setLibrary={setVideos} />
        </div>
      )}
      {activeTab === 1 && (
        <div>
          <Typography variant="h6" component="div" mt={2}>
            Episodios de podcast
          </Typography>
          <LibraryList library={podcasts} setLibrary={setPodcasts} />
        </div>
      )}
      {activeTab === 2 && (
        <div>
          <Typography variant="h6" component="div" mt={2}>
            Libros
          </Typography>
          <LibraryList library={books} setLibrary={setBooks} />
        </div>
      )}
      {activeTab === 3 && (
        <div>
          <Typography variant="h6" component="div" mt={2}>
            Artículos
          </Typography>
          <LibraryList library={articles} setLibrary={setArticles} />
        </div>
      )}
      <SaveContent library={[]} setLibrary={fetchData} />
    </DashboardContainer>
  );
};

export default Library;
